import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HelpConfig } from "src/app/core/config/help-config";

@Injectable({
  providedIn: "root",
})
export class ParameterService {
  url = `${this.helpConfig.BASE_API}parameter`;

  constructor(private http: HttpClient, private helpConfig: HelpConfig) {}

  getParameterMaximiumAndMinimumValue() {
    return this.http.get<{ minValueInspection: number; maxValueInspection: number }>(`${this.url}/MaximumAndMinimumValues`);
  }

  getSuportContactPhoneNumber(): Observable<string> {
    return this.http.get<string>(`${this.url}/GetSuportContactPhoneNumber`);
  }

  getValidadeHoras() {
    return this.http.get(`${this.url}/get/VALIDADE_HORAS`);
  }

  getMinOcrConfidence(): Observable<string> {
    return this.http.get<string>(`${this.url}/get/MIN_OCR_CONFIDENCE`);
  }
}
